import React, {Component} from 'react'
import { connect } from 'react-redux'
import SettingsPrice from './components/Settings/SettingsPrice'
import OnboardStep from './components/Onboard/OnboardStep'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class OnboardPriceContainer extends Component {

  render() {
    return <OnboardStep pathname="/onboard/client" {...this.props}>
      <SettingsPrice {...this.props} />
    </OnboardStep>
  }

}

export default connect((state) => ({ settings: state.onboard }), mapDispatchToProps)(OnboardPriceContainer)
